__turbopack_context__.v({
  "closeButton": "Modal-module-scss-module__CDT7RG__closeButton",
  "contactOrgFadeIn": "Modal-module-scss-module__CDT7RG__contactOrgFadeIn",
  "content": "Modal-module-scss-module__CDT7RG__content",
  "contentChildren": "Modal-module-scss-module__CDT7RG__contentChildren",
  "footer": "Modal-module-scss-module__CDT7RG__footer",
  "header": "Modal-module-scss-module__CDT7RG__header",
  "modal": "Modal-module-scss-module__CDT7RG__modal",
  "overlay": "Modal-module-scss-module__CDT7RG__overlay",
  "secondaryButton": "Modal-module-scss-module__CDT7RG__secondaryButton",
  "title": "Modal-module-scss-module__CDT7RG__title",
});
